import { NavLink } from 'react-router-dom';

function NotFound() {
  return (
    <section className="container mx-auto px-6 py-16 text-center">
      <p className="text-sm font-semibold uppercase tracking-widest text-gray-500">Erro 404</p>
      <h1 className="mt-4 text-4xl font-bold text-gray-900">Pagina nao encontrada</h1>
      <p className="mt-4 text-lg text-gray-600">
        A rota que voce tentou acessar nao existe neste site.
      </p>
      <NavLink
        to="/"
        className="mt-8 inline-flex rounded-md bg-gray-800 px-5 py-3 text-sm font-medium text-white transition hover:bg-gray-700"
      >
        Voltar para Home
      </NavLink>
    </section>
  );
}

export default NotFound;
